export const HAS_TRAILING_SLASH = true

export const SERVER_ROUTES = {
  healthCheck: '/health-check',
}
